"use client";

import { useEffect, useState } from "react";
import Lottie from "lottie-react";

import animationData from "@/lib/feed/saved-empty-animation.json";

export function SavedPostsEmptyAnimation() {
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setReduceMotion(media.matches);
    update();
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);

  return (
    <Lottie
      animationData={animationData}
      loop={!reduceMotion}
      autoplay={!reduceMotion}
      aria-hidden
      className="mx-auto size-[220px]"
    />
  );
}
